import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers } from '@angular/http';
import { SharedService } from '../../shared/shared.service';
@Injectable()

export class TagsService {
  public baseUrl: string; 
  constructor(private _http: Http, private _data: SharedService,) { 
    this.baseUrl = environment.apiUrl;
  }

  getlistTags(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'tags?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
	}
	
	getAllTags(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'allTags', { headers: headers })
			.map(res => res.json());
	}

	

  getTags(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.get(this.baseUrl + 'tags/' + data.id, { headers: headers })
			.map(res => res.json());
	}

  editTags(data: any) {

		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.put(this.baseUrl + 'tags/' + data.id, json, { headers: headers })
			.map(res => res.json());
	}

    newTags(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'tags', json, { headers: headers })
			.map(res => res.json());
	}

    newAssociation(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'tags-asociation', json, { headers: headers })
			.map(res => res.json());
	}

    updateAsocciation(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'tags-asociation-update', json, { headers: headers })
			.map(res => res.json());
	}

    changeClasification(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'change-clasification', json, { headers: headers })
			.map(res => res.json());
	}

	deleteTags(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.delete(this.baseUrl + 'tags/' + data.id, { headers: headers })
			.map(res => res.json());
	}

    getFiles1() {
        return this._http.get('assets/files.json')
          .toPromise()
          .then(res => res.json());
        }
    
    uploadfiles(file: any) {
        const headers = new Headers({});
        console.log("Esto es lo que se envía: ", file);
        headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));
        //headers.append('Content-Type', 'multipart/form-data'); da error al enviar la cabecera para los archivos
        return this._http.post(this.baseUrl + 'tags/add-tags-excel',
        file, { headers: headers }).map(res => res.json());
        }
        

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/tags/tags.service.ts